import { ShortElementTypeDTO, ShortElementTypeDTOFireProtectionTypeEnum } from '~/api/webservice';
import { IProductProperties, ISOPROProduct } from '~/models';
import { useProductsStore } from '~/store';

export class ISOPROProductShortElementType extends ISOPROProduct {
  declare readonly type: ShortElementTypeDTO["type"];
  declare readonly height: ShortElementTypeDTO["height"];
  declare readonly fireProtectionType: ShortElementTypeDTO["fireProtectionType"];
  declare readonly capacity: ShortElementTypeDTO["capacity"];

  declare readonly properties: {
    dimensions: ISOPROProduct["properties"]["dimensions"];
    construction: IProductProperties['construction'] & {
      thrustBearings: IProductProperties["construction"]["thrustBearings"] & {
        kindOfThrustBearing?: ShortElementTypeDTO["kindOfThrustBearing"];
      }
    }
  }

  constructor (data: ShortElementTypeDTO) {
    super(data);
    this.fireProtectionType = data.fireProtectionType;
    this.type = data.type;
    this.height = data.height;
    this.capacity = data.capacity;
    this.properties = {
      ...this.properties,
      construction: {
        ...this.properties.construction,
        thrustBearings: {
          ...this.properties.construction.thrustBearings,
          kindOfThrustBearing: data.kindOfThrustBearing
        }
      }
    }
  }

  getOneWithoutFireProtection (): ISOPROProductShortElementType | null {
    if (this.hasFireProtection) return null;
    const rowKey = `${this.rowKey} ${this.capacity >= 100
      ? ShortElementTypeDTOFireProtectionTypeEnum.R90
      : ShortElementTypeDTOFireProtectionTypeEnum.Rei120}`;
    return (useProductsStore().productsMap.get(rowKey) as ISOPROProductShortElementType) || null;
  }
}
